import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  AppBar,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import GridViewTwoToneIcon from "@mui/icons-material/GridViewTwoTone";
// import NotificationsNoneTwoToneIcon from "@mui/icons-material/NotificationsNoneTwoTone";
import { logoutThunk } from "../../redux/thunks/auth.thunk";
import { useAppDispatch } from "../../redux/store";
import { Link } from "react-router-dom";

interface IProps {
  title: string;
}

const MainHeader = ({ title }: IProps) => {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    dispatch(logoutThunk());
    handleClose();
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <AppBar position="static">
      <Box className="main-header">
        <Box className="page-title-container">
          <Avatar alt="Page title" className="margin-auto">
            <GridViewTwoToneIcon />
          </Avatar>
          <Typography variant="h6" className="margin-auto">
            {title}
          </Typography>
        </Box>
        <Box className="profile-container">
          {/* <Badge badgeContent={4} color="primary">
            <Avatar alt="Notification">
              <NotificationsNoneTwoToneIcon />
            </Avatar>
          </Badge> */}
          <IconButton onClick={handleClick}>
            <Avatar alt="user" src="/assets/images/demo-user.png" />
          </IconButton>
        </Box>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem>
          <Link to="/user/profile">Profile</Link>
        </MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </AppBar>
  );
};

export default MainHeader;
